import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { KiwixiService } from '../../../kiwixi/kiwixi.service';
import { ExaminationService } from '../../../service/examination.service';
import { MaterialService } from '../../../service/material.service';
import { SharedAppState } from '../../../store/app.states';
import { LilateCardRecComponent } from '../lilate-card-rec.component';

@Component({
  selector: 'app-lilate-card-booked-rec',
  templateUrl: './lilate-card-booked-rec.component.html',
  styleUrls: ['./lilate-card-booked-rec.component.scss', '../lilate-card-rec.component.scss']
})
export class LilateCardBookedRecComponent extends LilateCardRecComponent {

  @Input() bloc: string;

  constructor(
    _router: Router,
    materialService: MaterialService,
    translateService: TranslateService,
    kiwixiService: KiwixiService,
    examinationService: ExaminationService,
    store: Store<SharedAppState>,
    private route: ActivatedRoute
  ) {
    super(
      _router,
      materialService,
      translateService,
      kiwixiService,
      examinationService,
      store
    )
  }

  navigateToEditTargetedLevel(lilateId: number): void {
    // Extraire l'ID de formation de l'URL actuelle
    const urlSegments = this._router.url.split('/');
    const formationIndex = urlSegments.indexOf('formation');
    
    if (formationIndex !== -1 && urlSegments[formationIndex + 1]) {
      const formationId = urlSegments[formationIndex + 1];
      this._router.navigate(['/formation', formationId, 'edit-targeted-level', lilateId]);
    }
  }

}
